import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { css } from 'emotion';
import { useHistory } from 'react-router-dom';
import { get } from 'lodash';
import { InputField } from '../components/InputField';
import { ButtonContainer } from '../components/ButtonContainer';
import { MarketingOptions } from '../components/MarketingOptions';
import { Loader } from '../components/Loader';
import { CustomButton } from '../components/CustomButton';
import { InnerGrid } from '../components/InnerGrid';
import { useGetUserInfo, useUpdateOptions } from '../../api/api';

const customAlignment = css`
  flex-direction: column;
  @media only screen and (max-width: 879px) {
    width: 100%;
  }
  @media only screen and (min-width: 880px) {
    flex-direction: row;
    gap: 2.5rem;
  }
  @media only screen and (min-width: 768px) {
    justify-content: flex-end;
  }
`;
const threeRowStyle = css`
  @media (min-width: 768px) {
    padding-right: 0;
    grid-template-columns: Max(25vw, 14.5rem) 1fr Max(25vw, 14.5rem) !important;
  }
`;

const formContainerStyle = css`
  background-color: #ff7401;
  border-radius: 15px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto 0;

  @media (max-width: 768px) {
    margin: auto 1.25rem;
  }
`;

const titleStyle = css`
  color: #ffffff;
  font-size: 2.25rem;
  margin-bottom: 1.15rem;
`;

const infoStyle = css`
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.8;
  text-align: center;
  margin: 0 1.5rem 2rem;
`;

const nameContainerStyle = css`
  display: flex;
  width: 100%;
`;

const spaceBetweenStyle = css`
  width: 10%;
`;

const loaderStyle = css`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;



export const MainScreen = (props) => {
  const { mutate: getUserInfo, isLoading: userInfoLoading } = useGetUserInfo();
  const { mutate: updateOptions, isLoading: updating } = useUpdateOptions();

  useEffect(() => {
    getUserInfo();
  }, [])
  const history = useHistory();
  // console.log('Previous quote:', localStorage.previousQuote, !localStorage.previousQuote);
  const handleContinue = () => {
    console.log("Continue")
  };

  return (

    <InnerGrid customAlignment={threeRowStyle}>
      <div />
      {(userInfoLoading || updating)  && (
        <div className={loaderStyle}>
          <Loader/>
        </div>
      )}
      {!(userInfoLoading || updating) && (
        <div className={formContainerStyle}>
          <h3 className={titleStyle}>Marketing Options</h3>

          <p className={infoStyle}>
            Update your marketing options
          </p>


          <>
            <div className={nameContainerStyle}>
              <InputField
                name="firstName"
                id="firstName"
                placeholder="First Name"
                salesForce
                fullwidth
              />
              <div className={spaceBetweenStyle} />
              <InputField
                name="lastName"
                id="lastName"
                placeholder="Last Name"
                salesForce
                fullwidth
              />
            </div>
            <InputField
              name="email"
              id="email"
              placeholder="Email"
              salesForce
              fullwidth
            />
            <InputField
              name="phone"
              id="phone"
              type="number"
              placeholder="Phone"
              salesForce
              fullwidth
            />
          </>

          <MarketingOptions />


          <ButtonContainer customAlignment={customAlignment}>
            <CustomButton
              handleClick={async() => {
                 updateOptions()
              }}
              label="Update"
              salesForce
            />

          </ButtonContainer>
        </div>
      )}
    </InnerGrid>
  );
};
